import React, { useState } from 'react';
import { Box } from '@mui/material';
import PresetList from './components/PresetList';
import PresetFilters from './components/PresetFilters';
import PresetModal from './components/PresetModal';
import usePresets from './hooks/usePresets';

// Custom ID generator
const generateUniqueId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

const PresetsPanel = ({ onAddPreset, sectionOrder }) => {
  const {
    filteredPresets,
    searchTerm,
    setSearchTerm,
    selectedCategories,
    setSelectedCategories,
    selectedDealerships,
    setSelectedDealerships,
    presetModalOpen,
    setPresetModalOpen,
    editingPreset,
    setEditingPreset,
    presetForm,
    setPresetForm,
    openPresetModal,
    closePresetModal,
    handlePresetSave,
  } = usePresets();

  const [selectedPresetIds, setSelectedPresetIds] = useState([]); // Move state to PresetsPanel
  const [bulkAddOpen, setBulkAddOpen] = useState(false);
  const [targetSectionId, setTargetSectionId] = useState('');

  const handleTogglePreset = (presetId) => {
    setSelectedPresetIds(prev =>
      prev.includes(presetId)
        ? prev.filter(id => id !== presetId)
        : [...prev, presetId]
    );
  };

  const handleBulkAdd = () => {
    if (selectedPresetIds.length === 0) return;
    setBulkAddOpen(true);
  };

  const handleConfirmBulkAdd = () => {
    if (!targetSectionId) return;
    selectedPresetIds.forEach(presetId => {
      const numericPresetId = Number(presetId);
      if (isNaN(numericPresetId)) {
        return;
      }
      const newItem = {
        id: generateUniqueId(),
        presetId: numericPresetId,
        propertyId: null,
      };
      onAddPreset(targetSectionId, newItem);
    });
    setSelectedPresetIds([]);
    setTargetSectionId('');
    setBulkAddOpen(false);
  };

  return (
    <Box sx={{ width: 380, borderLeft: '1px solid #e0e0e0', pl: 2, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
      <PresetFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        selectedDealerships={selectedDealerships}
        setSelectedDealerships={setSelectedDealerships}
        openPresetModal={openPresetModal}
        selectedPresetIds={selectedPresetIds} // Pass for bulk add
        handleBulkAdd={handleBulkAdd}
      />
      <PresetList
        filteredPresets={filteredPresets}
        openPresetModal={openPresetModal}
        onAddPreset={(sectionId, newItem) => {
          const numericPresetId = Number(newItem.presetId);
          if (isNaN(numericPresetId)) {
            return;
          }
          onAddPreset(sectionId, newItem);
        }}
        sectionOrder={sectionOrder}
        selectedPresetIds={selectedPresetIds} // Pass for checkboxes
        handleTogglePreset={handleTogglePreset}
        bulkAddOpen={bulkAddOpen}
        setBulkAddOpen={setBulkAddOpen}
        targetSectionId={targetSectionId}
        setTargetSectionId={setTargetSectionId}
        handleConfirmBulkAdd={handleConfirmBulkAdd}
      />
      <PresetModal
        open={presetModalOpen}
        editingPreset={editingPreset}
        presetForm={presetForm}
        setPresetForm={setPresetForm}
        onClose={closePresetModal}
        onSave={handlePresetSave}
      />
    </Box>
  );
};

export default PresetsPanel;